import { Home } from 'lucide-react';
import { signIn } from 'next-auth/react';
import { type ReactElement } from 'react';

import { Button } from '@/components/button';
import { AppLayout } from '@/components/layouts/app-layout';
import { AuthenticatedWrapper } from '@/components/modules/authenticated-wrapper';
import { Landing } from '@/components/modules/landing';
import { DashboardView } from '@/components/views/dashboard';
import { SITE_NAME } from '@/lib/constants';
import { trackUser } from '@/utils/tracking';

const Page = (): ReactElement => {
  const handleCreateAccount = async () => {
    await signIn();
    trackUser.event('Go to: Create account', {
      location: 'Dashboard',
    });
  };

  const handleSignIn = async () => {
    await signIn();
    trackUser.event('Go to: Sign-in', {
      location: 'Dashboard',
    });
  };

  return (
    <AppLayout
      title={`Dashboard - ${SITE_NAME}`}
      breadcrumbItems={[{ label: 'Home' }, { label: 'Dashboard', icon: <Home className="text-lightBlue-500" /> }]}
    >
      <AuthenticatedWrapper
        fallback={
          <Landing
            actions={
              <>
                <Button onClick={handleSignIn}>Sign in to your account</Button>
                <Button onClick={handleCreateAccount} variant="primaryLightOutline">
                  Create an account
                </Button>
              </>
            }
            heading="You need a Fluent Cargo account to access your dashboard"
            subHeading="If you don't have one, it's free to create one and only takes a minute"
            imageUrl="https://www.datocms-assets.com/52833/1727919415-dashboard-preview.png"
            imageAlt="Dashboard"
          />
        }
      >
        <DashboardView />
      </AuthenticatedWrapper>
    </AppLayout>
  );
};

export default Page;
